export class Note {
  idNote: number;
  idUser: string;
  userName: string;
  email: string;
  status: number;
  note: string;
  statusName: string;
  fechaUltimaRespuesta: any;
  dateCreated: any;
  dateModify: any;
  responses: NoteResponse[];

  constructor(_note?) {
    let data = _note ? _note : {};  
    this.idNote = data.idNote || null;
    this.idUser = data.idUser || null;
    this.userName = data.userName || null;
    this.email = data.email || null;
    this.status = data.status || null;
    this.note = data.note || null;
    this.statusName = data.statusName || null;
    this.fechaUltimaRespuesta = data.fechaUltimaRespuesta || null;
    this.dateCreated = data.dateCreated || null;
    this.dateModify = data.dateModify || null;
    this.responses = data.responses  || null;
  }
}

export class NoteResponse {
  idNoteResponse: number;
  idNote: number;
  idUser: string;
  userName: string;
  userEmail: string;
  note: string;
  dateCreated: any;

  constructor(_noteResponse?) {
    let data = _noteResponse ? _noteResponse : {};
    this.idNoteResponse = data.idNoteResponse || null;
    this.idNote = data.idNote || null;
    this.idUser = data.idUser || null;
    this.userName = data.userName || null;
    this.userEmail = data.userEmail || null;
    this.note = data.note || null;
    this.dateCreated = data.dateCreated || null;
  }
}
